var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["account/templates/partials/payment-form/credit-card-default.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n<div class=\"c-form__field\">\n\n    <p class=\"c-form-adjacent\">\n\n        ";
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup(((lineno = 5, colno = 23, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"get"), "Address[\"get\"]", context, ["relationships"]))),"profile")),"profile")),"defaultPaymentId") == runtime.memberLookup(((lineno = 5, colno = 88, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"get"), "Address[\"get\"]", context, ["temp"]))),"id")) {
output += "\n\n            <input type=\"checkbox\" name=\"set-default-payment\" class=\"c-form-adjacent__checkbox js-account-set-default-payment\" id=\"set-default-payment\" checked data-qa-set-as-default-payment=\"checked\" />\n\n        ";
;
}
else {
output += "\n\n            <input type=\"checkbox\" name=\"set-default-payment\" class=\"c-form-adjacent__checkbox js-account-set-default-payment\" id=\"set-default-payment\" data-qa-set-as-default-payment=\"unchecked\" />\n\n        ";
;
}
output += "\n\n            <label for=\"set-default-payment\" class=\"c-form-adjacent__label\" data-qa-credit-card-set-as-default-text>\n                ";
output += runtime.suppressValue((lineno = 16, colno = 17, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_addressAndPayments-displayAddressesPayments-setAsDefault",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "\n            </label>\n\n    </p>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["account/templates/partials/payment-form/credit-card-default.j2"] , dependencies)